import { apiUtils } from '../utils/apiUtils'
import downloadjs from 'downloadjs'
import moment from 'moment'

const jsonHeaders = { 'Content-Type': 'application/json' }

export default {
  get: function (clientid) {
    return fetch(apiUtils.integrationEnroll + '/plateau/?clientId=' + clientid, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Aucun fichier plateau trouvé' }
      }
      return Promise.resolve({})
    })
  },
  upsert: function (code, plateau) {
    return fetch(apiUtils.integrationEnroll + '/plateau/' + code, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(plateau)
    })
  },
  download (filename) {
    const file = filename.file || filename.nom
    return fetch(apiUtils.integrationEnroll + '/plateau/' + file, {
      method: 'GET'
    })
      .then((response) => response.blob())
      .then((blob) => {
        downloadjs(blob, filename.nom)
      })
  },
  upload: function (file, model, clientid, code, nom, ext) {
    console.log('Sending file with : ', 'nom '+nom, '- code '+code, ' ext - '+ext)
    const data = new FormData()
    data.append('file', file.file)
    data.append('nom', nom)
    data.append('ext', ext)
    data.append('date', moment().format('YYYY-MM-DD HH:mm:ss'))
    return fetch(apiUtils.integrationEnroll + '/file/plateau/' + code, {
      method: 'POST',
      body: data
    }).then((res) => {
      if (res.status === 200 || res.status === 201) {
        return res.json().then(row => ({ ...row, nom: file.nom }))
      }
      return Promise.reject(new Error(`ERR_${res.status} - Erreur pendant l'envoi du fichier`))
    }).catch(err => Promise.reject(err instanceof Error ? err : new Error('ERR_Erreur pendant l\'envoi du fichier')))
  },
  getByEnrollId: function (enrollid) {
    return fetch(apiUtils.integrationEnroll + '/plateau/list/' + enrollid, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) return res.json()
      return []
    }).catch(() => [])
  },
  remove: function (file, model, code) {
    return fetch(apiUtils.integrationEnroll + '/plateau/' + code, {
      method: 'DELETE',
      headers: jsonHeaders,
      body: JSON.stringify({ nom: file.nom })
    })
  }
}
